import { TitleCasePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faCalendar, faCreditCard, faFileSignature, faGraduationCap, faPowerOff, faUser } from '@fortawesome/free-solid-svg-icons';
import { NgbCalendar, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import firebase from 'firebase/app';
import { Estudiante } from '../core/clases/estudiante.model';
import { Tutor } from '../core/clases/tutor.model';
import { CodigosPostales } from '../core/utilidades/codigos-postales';
import { FirebaseAuthComponent } from '../shared/firebase-auth/firebase-auth.component';
import { CustomDateParserFormatter } from '../shared/services/customDateParserFormatter/CustomDateParserFormatter';
import { SendEmailService } from '../shared/services/email/send-email.service';
import { InscripcionService } from '../shared/services/inscripcion/inscripcion.service';
import { MessagesService } from '../shared/services/messages/message.service';
import { TutorService } from '../shared/services/tutor/tutor.service';



@Component({
  selector: 'app-tutor',
  templateUrl: './tutor.component.html',
  providers: [

    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})

export class TutorComponent implements OnInit {

  cargando = 'ninguna';
  cargandoModal = false;
  banderaInfoAcademica = false;

  userIcon = faUser;
  graduationIcon = faGraduationCap;
  signatureIcon = faFileSignature;
  creditCardIcon = faCreditCard;
  powerOffIcon = faPowerOff;
  calendarIcon = faCalendar;

  idTutor: string;
  sexo = 'Mujer';
  documento = 'DNI';
  alumno = new Estudiante();
  alumnos: Array<Estudiante> = [];
  alumnosAux: Array<Estudiante> = [];
  parentescos: Array<any> = [];
  tipoVias: Array<any> = [];
  confirmacionEmail;
  confirmacionPassword;
  dobDatePicker;

  banderaDatosAlumnos = true;

  emailIguales = true;
  passwordIguales = true;
  modalAge = false;

  regexDNI = '^[0-9]{8}[A-Z]$';
  regexNIE = '^[A-Z]{1}[0-9]{7}[A-Z]$';
  regexPasaporte = '';
  documentoValido = true;

  codigosPostalesMap = new Map();
  errorFirebase = false;
  errorEdadTutor = false;
  headerTitle = 'INSCRIPCIÓN Información personal';
  img1 = '../../assets/img/menu/barra1.png';

  messageEmail = '';

  tutor = new Tutor();
  originTutor: string;
  cargandoSpinner = false;
  cargandoSpinnerEliminar = false;
  progreso: number;

  modoEdicion = false;
  existeDNI = false;

  isNotSubcribeAtras = true;
  actualizando = false;
  isCampus: boolean = false;

  email = new FormControl('', [
    Validators.required,
    Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
  ]);
  password = new FormControl('', [
    Validators.required,
    Validators.minLength(8)
  ]);

  campoText1 = new FormControl('', [
    Validators.required
  ]);
  campoText2 = new FormControl('', [
    Validators.required
  ]);
  campoText3 = new FormControl('', [
    Validators.required
  ]);

  validacionDNI = new FormControl('', [
    Validators.required,
    Validators.pattern(this.regexDNI),
  ]);
  validacionNIE = new FormControl('', [
    Validators.required,
    Validators.pattern(this.regexNIE),
  ]);
  validacionPasaporte = new FormControl('', [
    Validators.required,
    Validators.pattern(this.regexPasaporte),
  ]);
  campoNumeroDocumento = this.validacionDNI;

  campoText5 = new FormControl('', [
    Validators.required,
    Validators.pattern('^([0-9]){9,9}$'),
  ]);
  campoText6 = new FormControl('', [
    Validators.required
  ]);
  campoText7 = new FormControl('', [
    Validators.required,
    Validators.minLength(5),
    Validators.pattern('^[0-9]{5}$'),
  ]);
  campoText8 = new FormControl('', [
    Validators.required
  ]);

  campoText9 = new FormControl('', [
    Validators.required
  ]);
  campoNumeroDir = new FormControl('', [
    Validators.required
  ]);

  viaTypes = [{
        label: 'Alameda',
        value: 'Alameda'
      }, {
        label: 'Avenida',
        value: 'Avenida'
      }, {
        label: 'Calle',
        value: 'Calle'
      }, {
        label: 'Camino',
        value: 'Camino'
      }, {
        label: 'Carretera',
        value: 'Carretera'
      }, {
        label: 'Glorieta',
        value: 'Glorieta'
      }, {
        label: 'Pasaje',
        value: 'Pasaje'
      }, {
        label: 'Paseo',
        value: 'Paseo'
      }, {
        label: 'Plaza',
        value: 'Plaza'
      }, {
        label: 'Ronda',
        value: 'Ronda'
      }, {
        label: 'Parque',
        value: 'Parque'
      }, {
        label: 'Plazuela',
        value: 'Plazuela'
      }, {
        label: 'Bulevar',
        value: 'Bulevar'
      }];

  constructor(private firebaseAuth: FirebaseAuthComponent,
              private emailService: SendEmailService,
              private titlecasePipe: TitleCasePipe,
              private tutorService: TutorService,
              private cdRef: ChangeDetectorRef,
              private ngbCalendar: NgbCalendar,
              private dateAdapter: NgbDateAdapter<string>,
              private inscripcionService: InscripcionService,
              private cloudFunctions: AngularFireFunctions,
              private router: Router,
              private messageService: MessagesService) {
  }

  ngOnInit(): void {
    this.setProgress(25);
    if (localStorage.getItem('idTutor') != null) {
      this.idTutor = localStorage.getItem('idTutor');
      this.tutor.id = this.idTutor;
      this.actualizando = false;
      this.banderaInfoAcademica = false;
      this.atrasInfoAcademica();
    } else {
      this.showModalTestCode();
      this.sexo = 'hombre';
      this.alumno.sexo = 'hombre';
      this.alumno.status = 'prospectivo';
      this.alumno.appCreacion = 'nuevapantalla';
      this.alumnos.push(this.alumno);
      this.tutor.tipoVia = 'Calle';
      this.tutor.parentesco = 'Madre';
      this.tutor.medioContacto = 'Escuela';
      this.originTutor = '/origin/QwtMlg0lXYjUVHco9idX';
      this.codigosPostalesMap = new CodigosPostales().codigosPostalesMap;
      this.tutorService.currentIdTutor$.subscribe(res => {
        this.tutor.id = res;
        localStorage.setItem('idTutor', this.tutor.id);
        this.atrasInfoAcademica();
        this.banderaInfoAcademica = false;
      });
    }
    // tslint:disable-next-line: deprecation
    this.tutorService.suscribeHeader().subscribe(value => {
      this.headerTitle = value.title;
      this.img1 = value.img1;
      this.cdRef.detectChanges();
    });
    this.setProgress(100);
    this.cargandoSpinner = false;
    this.cargandoSpinnerEliminar = false;
  }

  showModalTestCode(): void {
    const functionYesNot = () => {
      return Promise.resolve(true);
    };
    this.messageService.showFormInDialogButtons([], '¿Tienes ya tu código de prueba gratuita?', '', functionYesNot,
      'No', 'Sí', true, true, 'my-custom-just-buttons', 'Guardado Correctamente', true)
      .afterClosed().toPromise()
      .then(response => {
        if (response.object) {
          const form = this.buildFormModal();
          const functionCode = (formGroup: FormGroup) => {
            return Promise.resolve(formGroup);
          };
          this.messageService.showFormInDialogButtons(form, 'Solicitud de código', '', functionCode,
            'Enviar', 'Cancelar', true, true, 'my-custom-just-buttons')
            .afterClosed().toPromise()
            .then(formulario => {
              if (typeof formulario === 'object') {
                this.cargandoModal = true;
                this.cloudFunctions.httpsCallable('solicitudCodigoPrueba')({
                  correo: formulario.object.value.email,
                  numeroAlumnos: formulario.object.value.alumnNumber
                }).toPromise()
                  .then(responseCode => {
                    this.cargandoModal = false;
                    const message = `Te hemos enviado tu código de prueba al correo
            que nos has facilitado.<br> Si no lo recibes, recuerda
            revisar tu bandeja de correos no deseados`;
                    this.messageService.openAlertDialog(message, '¡Ya puedes completar tu inscripción!', 'Cerrar', '',
                      'short-message-button-center');
                  })
                  .catch(error => {
                    this.cargandoModal = false;
                    this.messageService.openAlertDialog(error, 'Error');
                  });
              }
            })
            .catch();
        }
      });
  }

  checkConditionsModal(form: any[], formGroup: FormGroup, element: any, document?: any): Promise<any> {
    formGroup.get(element.name).setValue(!element.checked);
    element.checked = !element.checked;
    return Promise.resolve(formGroup);
  }

  buildFormModal(): any[] {
    const form = [{
      element: 'email', name: 'email', label: 'Envíame mi código de prueba gratuita*', labelClass: "text-left", placeholder: 'Correo electrónico',
      validations: [Validators.required]
    }, {
      element: 'number', name: 'alumnNumber', value: 1, label: "Número de alumnos", labelClass: "text-center h6", inputClass: "custom-input-number text-center", containerClass: "w-50", min: 1, max: 3, validations: [Validators.required, Validators.min(1), Validators.max(3)]
    }, {
      element: 'checkbox', name: 'condiciones',
      value: false, href: 'https://www.playbots.es/politica-de-privacidad/',
      label: 'Acepto la Política de Privacidad', elementClass: "text-center", link: true, event: this.checkConditionsModal, typeEvent: 'click',
      checked: false, validations: [Validators.required]
    }, { element: 'captcha', elementClass: 'text-center', name: 'recaptcha', validations: [Validators.required] }];
    const list = [{ element: 'list', list: form },
    ];
    return list;
  }

  setProgress(percent: number) {
    this.progreso = percent;
    this.cargandoSpinner = percent < 100;
    this.cdRef.markForCheck();    
    this.cdRef.detectChanges();
  }

  setProgressAtras(percent: number) {
    this.progreso = percent;
    this.cargandoSpinner = percent < 100;
    this.cargandoSpinner = false;
    this.cargandoSpinnerEliminar = false;
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
  }

  get today() {
    return this.dateAdapter.toModel(this.ngbCalendar.getToday())!;
  }
  
  crearUserTutor(): void {
    
    this.errorFirebase = false;
    const tutorInfo = {...this.tutor}
    tutorInfo.alumns = [];
    tutorInfo.userType = 'tutor';
    tutorInfo.sexo = this.sexo.toLowerCase();
    tutorInfo.document = this.documento;
    tutorInfo.appCreacion = 'nuevapantalla';
    tutorInfo.paymentMethod = firebase.firestore().doc('/payment_methods/AsVzKZ33P2kzDTqQYsrM');
    tutorInfo.password = btoa(this.tutor.password);
    tutorInfo.city = this.tutor.municipality;
    if (this.originTutor != null) {
      tutorInfo.originTutor = firebase.firestore().doc(this.originTutor);
    } else {
      tutorInfo.originTutor = firebase.firestore().doc('/origin/QwtMlg0lXYjUVHco9idX');
    }
    tutorInfo.contactFormTutor = 'Email';
    tutorInfo.phone2 = '0';
    tutorInfo.isCampus = this.isCampus;
    this.aplicarTitlecasePipeAlumnosYTutor();
    if (this.modoEdicion) {
      console.log('entro al modo edición');
      this.actualizarDatos();
    } else {
      this.tutorService.getUsers(this.tutor.numberDNI).get().then(users => {
        console.log('modo creacion')
        if (users.empty) {
          console.log('tutor info', tutorInfo)
          this.firebaseAuth.createUser(tutorInfo, this.alumnos).then(res => {
            console.log('then create user', res)
              this.idTutor = res;
              this.router.navigate(['/infoacademica']);
              this.actualizarIdTutor();
              this.enviarEmail('Confirmación registro Playbots', this.emailAnexo1(tutorInfo.fullname, tutorInfo.sexo), this.tutor.email);
            }
          ).catch((error) => {
            this.errorFirebase = true;
            console.log('error al crear tutor y alumnos' + error);
          });
        }
        else {
          this.existeDNI = true;
        }
      });
    }
  }


  aplicarTitlecasePipeAlumnosYTutor(): void {
    this.alumnos.forEach(element => {
      element.firstname = this.titlecasePipe.transform(element.firstname);
      element.lastname = this.titlecasePipe.transform(element.lastname);
    });
    this.tutor.firstname = this.titlecasePipe.transform(this.tutor.firstname);
    this.tutor.lastname = this.titlecasePipe.transform(this.tutor.lastname);
    this.tutor.address = this.titlecasePipe.transform(this.tutor.address);
    this.tutor.city = this.titlecasePipe.transform(this.tutor.city);
    this.tutor.municipality = this.titlecasePipe.transform(this.tutor.municipality);
  }

  calcularEdadAlumno(alumno): number {
    if (alumno.dobDatePicker != null) {
      const fechaNacimiento = new Date(alumno.dobDatePicker.year, alumno.dobDatePicker.month - 1, alumno.dobDatePicker.day);
      const timeDiff = Math.abs(Date.now() - fechaNacimiento.getTime());
      const age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
      alumno.dob = fechaNacimiento;
      if (age < 5) {
        this.messageService.openAlertDialog('Es posible que para menores de 5 años no tengamos cursos disponibles', 'Advertencia');
      }
      return age;
    }
  }

  calcularEdadTutor(tutor): number {
    this.errorEdadTutor = false;
    if (tutor.dobDatePicker != null) {
      const fechaNacimiento = new Date(tutor.dobDatePicker.year, tutor.dobDatePicker.month - 1, tutor.dobDatePicker.day);
      const timeDiff = Math.abs(Date.now() - fechaNacimiento.getTime());
      const age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
      tutor.dob = fechaNacimiento;
      if (age < 18) {
        this.errorEdadTutor = true;
      }

      return age;
    }
  }

  onChangeDocumento(event) {
    switch (event) {
      case 'DNI':
        this.campoNumeroDocumento = this.validacionDNI;
        break;
      case 'NIE':
        this.campoNumeroDocumento = this.validacionNIE;
        break;
      case 'passport':
        this.campoNumeroDocumento = this.validacionPasaporte;
        break;
    }

    this.documento = event;
    this.tutor.numberDNI = '';
    this.campoNumeroDocumento.reset();
  }

  agregarAlumno(): void {
    const alumnoNuevo = new Estudiante();
    alumnoNuevo.sexo = 'hombre';
    alumnoNuevo.status = 'prospectivo';
    alumnoNuevo.appCreacion = 'nuevapantalla';
    this.alumnos.push(alumnoNuevo);
    if (this.modoEdicion) {
      this.crearAlumnoNuevoBD(alumnoNuevo);
    }
  }

  eliminarAlumno(index): void {
    if (this.modoEdicion) {
      this.cargandoSpinnerEliminar = true;
      const idAlumno = this.alumnos[index].id;
      this.eliminarAlumnoReferenciaTutorBD(idAlumno, index);
    } else {
      this.alumnos.splice(index, 1);
    }

  }


  validarEmails(): void {
    this.emailIguales = true;
    if ((this.tutor.email !== null && this.tutor.email !== '')
      && (this.confirmacionEmail != null && this.confirmacionEmail !== '')) {
      if (this.tutor.email === this.confirmacionEmail) {
        this.emailIguales = false;
      }
    }
  }
  validarPassword(): void {
    this.passwordIguales = true;
    if ((this.tutor.password != null && this.tutor.password !== '')
      && (this.confirmacionPassword != null && this.confirmacionPassword !== '')) {
      if (this.tutor.password === this.confirmacionPassword) {
        this.passwordIguales = false;
      }
    }
  }

  verificarCamposAlumnos(): void {
    this.banderaDatosAlumnos = false;
    this.alumnos.forEach(element => {
      if (element.firstname == null || element.firstname == ''
        || element.lastname == null || element.lastname == '' ||
        element.age == null) {
        this.banderaDatosAlumnos = true;
      }
    });

  }

  campoVacioNombre(campo, alumno): void {
    if (campo === '') {
      alumno.campoVacioNombre = 'alerta';
    } else {
      alumno.campoVacioNombre = 'sinalerta';
    }
  }
  campoVacioApellido(campo, alumno): void {
    if (campo === '') {
      alumno.campoVacioApellido = 'alerta';
    } else {
      alumno.campoVacioApellido = 'sinalerta';
    }
  }
  campoVacioDob(campo, alumno): void {
    if (campo === null || campo === '') {
      alumno.campoVacioDob = 'alerta';
    } else {
      alumno.campoVacioDob = 'sinalerta';
    }
  }

  obtenerMunicipioXCodigoPostal(codigoPostal): void {
    const municipio = this.codigosPostalesMap.get(codigoPostal);
    this.tutor.municipality = municipio;
    this.tutor.city = municipio;
  }

  logout(): void {
    try {
      this.firebaseAuth.eliminarInscripcionesAlumnos(this.alumnosAux);
      localStorage.removeItem('idTutor');
    } catch (error) {
      console.log('alerta eliminando datos' + error);
    }

    this.firebaseAuth.logout();
  }

  validarDoc(numeroDocumento): void {
    if (numeroDocumento != null) {
      this.documentoValido = true;
      this.existeDNI = false;
      if (this.documento === 'DNI') {
        this.validarDNI(numeroDocumento);
      }
      if (this.documento === 'NIE') {
        let niePrefix = numeroDocumento.charAt(0);
        switch (niePrefix) {
          case 'X': niePrefix = 0; break;
          case 'Y': niePrefix = 1; break;
          case 'Z': niePrefix = 2; break;
        }
        this.validarDNI(niePrefix + numeroDocumento.substr(1));
      }
    }
  }

  validarDNI(dni): void {
    const dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    const letter = dniLetters.charAt(parseInt(dni, 10) % 23);
    this.documentoValido = letter === dni.charAt(8);
  }

  enviarEmail(subjectToSend: string, messageToSend: string, emailToSend: string): Promise<any> {
    return this.emailService.sendEmail(subjectToSend, messageToSend, emailToSend)
      .then((responseSus) => {
        console.log('el resultado de la function es ', responseSus);
        if (responseSus) {
          if (responseSus.error) {
          }
        }
        return responseSus;
      }).catch(error => {
      });
  }

  maskText(text: string): string {
    let textMasked = '';
    let i = 0;
    let cont = 0;
    while (i < text.length) {
      if (cont === 2 || cont === 3) {
        textMasked += '*';
        if (cont === 3) {
          cont = 0;
        }
      } else {
        textMasked += text.charAt(i);
      }
      i++;
      cont++;
    }
    return textMasked;
  }

  emailAnexo1(fullname: string, sexo: string): string {
    // anexo 1
    this.messageEmail = `<div style ="text-align: justify;">
    Hola ${fullname}, <br/>
    ya estás registrad${sexo == "mujer" ? "a": "o"} en Playbots. Tus datos de acceso al Área del Tutor son: <br/><br/>

    https://playbots-areadeltutor.web.app/ <br/><br/>

    Usuario: ${this.tutor.email} <br/>
    Contraseña: ${this.maskText(this.tutor.password)}<br/><br/>

    Gracias por tu registro.<br/>

    <img class="product-image" style="max-width: 100%;"
    src="https://firebasestorage.googleapis.com/v0/b/playbotscms.appspot.com/o/logo_playbots.png?alt=media&token=2ddbe96b-349c-4819-8b2e-18256f0ef7ff" />
    <br/><br/>

    Avda. de las Civilizaciones 15, local 9<br/>
    41927 Mairena del Aljarafe, Sevilla<br/>
    Tlf.: 854993164 - info@playbots.es<br/><br/>

    Este correo electrónico y, en su caso, cualquier fichero anexo, contiene información confidencial <br/>
    exclusivamente dirigida a su(s) destinatario(s). Toda copia o divulgación deberá ser autorizada por <br/>
    Playbots Education S.L. <br/><br/>

    This e-mail and any attachments are confidential and exclusively directed to its address(es). Any<br/>
    copy or distribution will have to be authorized by Playbots Education S.L.<br/><br/>

    En virtud de la ley 34/2002 LSSI-CE, este mensaje y sus archivos adjuntos pueden contener<br/>
    información confidencial, por lo que se informa de que su uso no autorizado está prohibido por la<br/>
    ley, además se encuentran protegidos por la Constitución Española, que garantiza la<br/>
    confidencialidad, protección y secreto de las comunicaciones. Si ha recibido este mensaje por<br/>
    equivocación, por favor notifíquelo inmediatamente a través de esta misma vía y borre el mensaje<br/>
    original junto con sus ficheros adjuntos sin leerlo o grabarlo total o parcialmente. Los datos<br/>
    personales que consten en esta comunicación son responsabilidad de Playbots Education S.L.<br/>
    con la finalidad de gestionar la relación con nuestros clientes y contactos en relación al ejercicio<br/>
    de nuestra actividad, todo ello bajo la legitimación otorgada por consentimiento expreso del propio<br/>
    interesado, y/o en base a la ejecución de un contrato de servicios. No se cederán datos a terceros<br/>
    salvo obligaciones legales. En cuanto a sus derechos podrá acceder, rectificar y suprimir los datos,<br/>
    limitarlos o incluso oponerse a su tratamiento, entre otros derechos, contactando con nosotros por<br/>
    email o por correo postal dirigido a Avda. de las Civilizaciones 15, local 9 - 41927 Mairena del<br/>
    Aljarafe, Sevilla.<br/><br/>

    </div>`;

    return this.messageEmail;
  }

  atrasInfoAcademica(): void {
    if (!this.actualizando) {
      this.modalAge = false;
      this.alumnos = [];
      this.cargandoSpinner = true;
      this.modoEdicion = true;
      this.codigosPostalesMap = new CodigosPostales().codigosPostalesMap;
      this.banderaInfoAcademica = false;
      this.password.disable();
      this.email.disable();
      this.setProgressAtras(50);
      this.idTutor = this.tutor.id;
      this.obtenerTutor(this.tutor.id);
      this.isNotSubcribeAtras = false;
    }
  }

  obtenerTutor(id): void {
    this.tutorService.getUser(id).subscribe(res => {
      if (!this.banderaInfoAcademica) {

        // if (res.password) {
        //   this.password.setValue(res.password);
        //   this.confirmacionPassword = res.password;
        // }
        this.tutor = {
          ...res
        };

        if (!this.actualizando) {
          this.confirmacionEmail = this.tutor.email;
          this.documento = this.tutor.document;
          this.sexo = this.tutor.sexo;
          this.asignarValidacionTipoDoc(this.tutor.document);
          this.errorEdadTutor = false;
          if (this.tutor != null) {
            this.establecerDatosAlumnos(this.tutor.alumns);
          }
          this.setProgressAtras(100);
          this.cdRef.detectChanges();
        }

      }
    });
  }

  asignarValidacionTipoDoc(documento): void {
    switch (documento) {
      case 'DNI': {
        this.campoNumeroDocumento = this.validacionDNI;
        break;
      }
      case 'NIE': {
        this.campoNumeroDocumento = this.validacionNIE;
        break;
      }
      case 'passport': {
        this.campoNumeroDocumento = this.validacionPasaporte;
        break;
      }
      default: {
        this.campoNumeroDocumento = this.validacionDNI;
        break;
      }
    }
  }

  async establecerDatosAlumnos(alumnosTutor): Promise<void> {
    if (!this.actualizando) {
      if (alumnosTutor != null) {
        this.alumnosAux = [];
        await alumnosTutor.forEach(async element => {
          await this.tutorService.getUser(element.id).subscribe(res => {
            if (!this.actualizando) {
              this.agregarAlumnoDesdeBd(res);
            }
          });
        });
      }
      this.cargandoSpinner = false;
    }
  }
  agregarAlumnoDesdeBd(alumno): void {
    let banderaInsertar = true;
    this.alumnos.forEach(element => {
      if (element.id == alumno.id) {
        banderaInsertar = false;
      }
    });
    if (banderaInsertar) {
      this.alumnos.push(alumno);
      this.verificarCamposAlumnos();
    }
    this.alumnosAux.push(alumno);
  }

  public eliminarAlumnoReferenciaTutorBD(alumnoId, index): void {
    try {
      this.tutorService.removerEstudianteTutor(this.tutor.id, alumnoId).then(() => {
      }).catch((error) => {
        console.log('error al eliminar referencia alumno del tutor ' + error);
      });
    } catch (e) {
    }
    this.eliminarAlumnoBD(alumnoId, index);
  }

  eliminarAlumnoBD(alumnoId, index): any {
    try {
      const incripcionSubcription = this.inscripcionService.obtenerInscripcionPorAlumno(alumnoId).subscribe(res => {
        const inscripcionId = res.docs[0].id;
        incripcionSubcription.unsubscribe();
        this.inscripcionService.eliminarInscripcionRegistro(inscripcionId).then(() => {
          this.tutorService.eliminarEstudiante(alumnoId).then(() => {
            this.alumnos.splice(index, 1);
            this.cargandoSpinnerEliminar = false;
            this.verificarCamposAlumnos();
          }).catch((error) => {
            console.log('error al eliminar alumno  ' + error);
            this.cargandoSpinnerEliminar = false;
          });
        }).catch((error) => {
          console.log('error al eliminar inscripcion  ' + error);
        });
      });
    } catch (e) {
      this.cargandoSpinnerEliminar = false;
    }
  }

  crearAlumnoNuevoBD(alumno): void {
    this.cargandoSpinner = true;
    const idAlum = (Date.now().toString(36) + Math.random().toString(36).substr(2, 22));
    alumno.id = idAlum;
    alumno.userType = 'student';
    alumno.status = 'prospectivo';
    alumno.tutor = [];
    alumno.tutor.push(firebase.firestore().doc(`/users/${this.tutor.id}`));
    alumno.fullname = 'En Modo Edicion';
    alumno.sexo = 'hombre';
    alumno.appCreacion = 'nuevapantalla';
    alumno.registrationDate = new Date();
    alumno.showStudent = false;
    this.firebaseAuth.crearAlumno(alumno, this.tutor).then(res => {
      this.cargandoSpinner = false;
    }).catch((error) => {
      console.log('error al crear alumno  ' + error);
      this.cargandoSpinner = false;
    });

  }

  async actualizarDatos(): Promise<any> {
    this.actualizando = true;
    this.cargandoSpinnerEliminar = false;
    await this.tutorService.updateUserTutorRegistro(this.tutor).then(() => {
    }).catch((error) => {
      console.log('error al actualizar el tutor  ' + error);
      this.cargandoSpinnerEliminar = false;
    });
    for (let i = 0; i < this.alumnos.length; i++) {
      const incripcionSubcription = await this.inscripcionService.obtenerInscripcionPorAlumno(this.alumnos[i].id).subscribe(async res => {
        if (res.docs[0] != null) {
          const inscripcionId = res.docs[0].id;
          incripcionSubcription.unsubscribe();
          await this.inscripcionService.updateInscripcionRegistro(this.alumnos[i], this.tutor, inscripcionId).then(() => {
          }).catch((error) => {
            console.log('error al actualizar la inscripcion  ' + error);
          });
        }
      });

      await this.tutorService.updateEstudianteRegistro(this.alumnos[i]).then(() => {
      }).catch((error) => {
        console.log('error al actualizar el alumno  ' + error);
        this.cargandoSpinnerEliminar = false;
      });
    }
    this.cargandoSpinnerEliminar = false;
    this.banderaInfoAcademica = true;
    this.setProgressAtras(100);
    this.actualizarIdTutor();
    this.router.navigate(['/infoacademica']);
  }

  actualizarIdTutor(): void {
    setTimeout(() => {
      this.tutorService.changeIdTutor(this.idTutor);
    }, 500);
  }
}
